import { FeatureDefinition } from '../entities';

export const installCampaign2SenderExperiment = 'appnebula_app_install_campaign_2_sender';

export enum InstallCampaign2SenderExperimentGroups {
  CONTROL = 'control',
  TEST = 'test',
}

export const installCampaign2SenderExperimentConfig: FeatureDefinition = {
  defaultValue: InstallCampaign2SenderExperimentGroups.CONTROL,
};
